import { render, staticRenderFns } from "./SendOneRequestPost.vue?vue&type=template&id=31d6a13a&scoped=true&"
import script from "./SendOneRequestPost.vue?vue&type=script&lang=js&"
export * from "./SendOneRequestPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d6a13a",
  null
  
)

export default component.exports